<div class="registers-div">
    <form [formGroup]="formGroup" class="w100">
        <div class="div-wrap">
            <div [ngClass]="isManager ? 'w45' : 'w100'">
                <smt-date-input [group]="formGroup" [controlName]="'publicationDate'"
                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.INFO.PUBLICATION_DATE'"></smt-date-input>
            </div>

            <mat-form-field *ngIf="isManager" class="w45">
                <mat-label>
                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.INFO.PUBLICATION_USER' | translate
                    }}</mat-label>
                <textarea matInput cdkTextareaAutosize formControlName="publicationUser"></textarea>
            </mat-form-field>
        </div>
        <mat-accordion *ngIf="record; else noRecord">
            <div class="accordion-div">
                <mat-expansion-panel #panel class="expansion-panel" [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{formGroup.get('recordName').value}}</mat-panel-title>
                        <mat-panel-description>
                            <mat-icon>dvr</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div class="div-wrap">
                        <mat-form-field class="w100">
                            <mat-label>
                                {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.INFORMATION.SCOPE_CONTENT' | translate
                                }}</mat-label>
                            <textarea matInput cdkTextareaAutosize formControlName="recordScopeContent"></textarea>
                        </mat-form-field>
                    </div>

                    <div class="action-buttons" *ngIf="formGroup.get('recordId').value as id">
                        <button mat-raised-button color="primary" (click)="viewReg(id)"
                            *ngIf="isManager || record.draft === false"
                            [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.VIEW_ITEM' | translate">
                            <mat-icon>visibility</mat-icon> {{ 'APP.ACTIONS.VIEW' | translate }}
                        </button>
                    </div>
                </mat-expansion-panel>
            </div>
        </mat-accordion>
        <ng-template #noRecord>
            <mat-card class="center warn">
                <mat-card-content>
                    El registro del BOUD publicado ha sido eliminado.
                </mat-card-content>
            </mat-card>
        </ng-template>
    </form>
</div>